// src/components/transparency/transparency-button.tsx
function _array_like_to_array(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _array_with_holes(arr) {
  if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _iterable_to_array_limit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _non_iterable_rest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _sliced_to_array(arr, i) {
  return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
function _unsupported_iterable_to_array(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _array_like_to_array(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
  var data = _tagged_template_literal(["\n  fragment AdTransparencyButtonFragment on AdTransparencyButton {\n    primary\n    icon {\n      id\n    }\n  }\n"]);
  _templateObject = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject1() {
  var data = _tagged_template_literal(["\n  fragment EGDSExpandoPeekFragment on EGDSExpandoPeek {\n    expandedLabel\n    collapsedLabel\n    expanded\n    collapseAnalytics {\n      eventType\n      linkName\n      referrerId\n      uisPrimeMessages {\n        messageContent\n        schemaName\n      }\n    }\n    expandAnalytics {\n      eventType\n      linkName\n      referrerId\n      uisPrimeMessages {\n        messageContent\n        schemaName\n      }\n    }\n  }\n"]);
  _templateObject1 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject2() {
  var data = _tagged_template_literal(["\n  fragment EGDSInlineLinkFragment on EGDSInlineLink {\n    text\n    action {\n      ...UILinkActionFragment\n    }\n  }\n"]);
  _templateObject2 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject3() {
  var data = _tagged_template_literal(["\n  fragment UILinkActionFragment on UILinkAction {\n    accessibility\n    analytics {\n      referrerId\n      linkName\n      urls\n    }\n    resource {\n      ... on HttpURI {\n        value\n      }\n    }\n    target\n  }\n"]);
  _templateObject3 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject4() {
  var data = _tagged_template_literal(["\n  fragment TransparencyContentFragment on TransparencyOverlay {\n    entities {\n      ...EntityFragment\n    }\n    targetingCategories {\n      ...TargetingCategoriesFragment\n    }\n    callToAction {\n      size\n      ...EGDSInlineLinkFragment\n    }\n  }\n\n  fragment EntityFragment on TransparencyEntity {\n    label\n    expando {\n      ...EGDSExpandoPeekFragment\n    }\n    names\n  }\n  fragment TargetingCategoriesFragment on TargetingCategories {\n    heading {\n      text\n    }\n    items {\n      listItems {\n        text\n      }\n    }\n  }\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject4 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject5() {
  var data = _tagged_template_literal(["\n  query TransparencyQuery($context: ContextInput!, $adTransparencyId: String!) {\n    sponsoredContent {\n      transparencyOverlay(context: $context, adTransparencyId: $adTransparencyId) {\n        ...TransparencyContentFragment\n      }\n    }\n  }\n\n  ", "\n"]);
  _templateObject5 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject6() {
  var data = _tagged_template_literal(["\n  fragment TransparencyFragment on AdTransparencyTrigger {\n    adTransparencyId\n    adTransparencyButton {\n      ...AdTransparencyButtonFragment\n    }\n    adTransparencyOverlaySkeleton {\n      ...TransparencyOverlaySkeletonFragment\n    }\n  }\n\n  fragment TransparencyOverlaySkeletonFragment on TransparencyOverlaySkeleton {\n    title\n    error {\n      ...TransparencyOverlayErrorFragment\n    }\n  }\n\n  fragment TransparencyOverlayErrorFragment on TransparencyOverlayError {\n    icon {\n      id\n      size\n    }\n    description\n    button {\n      primary\n    }\n    allowedRetryAttempts\n    exceededAttemptsMessage\n  }\n\n  ", "\n"]);
  _templateObject6 = function _templateObject() {
    return data;
  };
  return data;
}
import React from "react";
import { gql } from "@apollo/client";
import { ButtonCustomExtraSmallWithIcon } from "@egds/react-sponsored-content";
import { useDialog } from "@shared-ui/dialog-context";
import { UitkIcon } from "uitk-react-icons";
import { UitkMoreInfoTrigger } from "uitk-react-more-info-trigger";
var fragment = gql(_templateObject());
var TransparencyTriggerType = /* @__PURE__ */function (TransparencyTriggerType3) {
  TransparencyTriggerType3["DISPLAY_AD"] = "display_ad";
  TransparencyTriggerType3["NATIVE_AD"] = "native_ad";
  return TransparencyTriggerType3;
}(TransparencyTriggerType || {});
var TransparencyButton = function (param) {
  var transparencyId = param.transparencyId,
    _param_type = param.type,
    type = _param_type === void 0 ? "native_ad" /* NATIVE_AD */ : _param_type,
    className = param.className,
    data = param.data;
  var _useDialog = _sliced_to_array(useDialog("transparency-dialog-".concat(transparencyId)), 2),
    dialogActions = _useDialog[1];
  var openDialog = function () {
    dialogActions.openDialog();
  };
  switch (type) {
    case "native_ad" /* NATIVE_AD */:
      var _data_icon;
      return /* @__PURE__ */React.createElement(ButtonCustomExtraSmallWithIcon, {
        onClick: openDialog,
        className: className
      }, /* @__PURE__ */React.createElement(React.Fragment, null, data.primary, /* @__PURE__ */React.createElement(UitkIcon, {
        name: ((_data_icon = data.icon) === null || _data_icon === void 0 ? void 0 : _data_icon.id) || "info"
      })));
    case "display_ad" /* DISPLAY_AD */:
      return /* @__PURE__ */React.createElement(UitkMoreInfoTrigger, {
        onClick: openDialog
      }, /* @__PURE__ */React.createElement("button", {
        type: "button"
      }, data.primary, /* @__PURE__ */React.createElement(UitkIcon, {
        name: "info_outline"
      })));
  }
};
TransparencyButton.displayName = "sharedui-transparencyButton";
TransparencyButton.fragment = fragment;
// src/components/transparency/transparency-overlay.tsx
import React7, { useEffect } from "react";
import { gql as gql5, useLazyQuery } from "@apollo/client";
import { useBexApi } from "@shared-ui/bex-api-context";
import { useDialog as useDialog2 } from "@shared-ui/dialog-context";
// ../internal/src/components/utils/constants.ts
var DEFAULT_SPONSORED_FETCH_POLICY = "no-cache";
// src/components/transparency/transparency-overlay.tsx
import { ViewMedium, Viewport, ViewSizes, ViewSmall } from "@shared-ui/viewport-context";
import { UitkSheet, UitkSheetTransition } from "uitk-react-sheet";
import { UitkToolbar } from "uitk-react-toolbar";
// src/components/transparency/__private/__fragments/transparency-content.tsx
import React4 from "react";
import { gql as gql4 } from "@apollo/client";
// ../internal/src/components/egds-expando/egds-expando.tsx
import React2 from "react";
import { gql as gql2 } from "@apollo/client";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
import { UitkExpandoPeek } from "uitk-react-expando";
var fragment2 = gql2(_templateObject1());
var EGDSExpandoPeek = function (param) {
  var lines = param.lines,
    items = param.items,
    hideScrim = param.hideScrim,
    data = param.data,
    children = param.children;
  var _expandAnalytics, _expandAnalytics1, _collapseAnalytics, _collapseAnalytics1;
  var expandAnalytics = data.expandAnalytics,
    collapseAnalytics = data.collapseAnalytics,
    expanded = data.expanded,
    expandedLabel = data.expandedLabel,
    collapsedLabel = data.collapsedLabel;
  var _React2_useState = _sliced_to_array(React2.useState(expanded), 2),
    isVisible = _React2_useState[0],
    setIsVisible = _React2_useState[1];
  var handleClick = React2.useCallback(function () {
    setIsVisible(!isVisible);
  }, [isVisible, setIsVisible]);
  var clickTracker = useClickTracker();
  var _expandAnalytics_referrerId, _expandAnalytics_linkName;
  var expandoExpandAnalytics = {
    id: (_expandAnalytics_referrerId = (_expandAnalytics = expandAnalytics) === null || _expandAnalytics === void 0 ? void 0 : _expandAnalytics.referrerId) !== null && _expandAnalytics_referrerId !== void 0 ? _expandAnalytics_referrerId : "",
    description: (_expandAnalytics_linkName = (_expandAnalytics1 = expandAnalytics) === null || _expandAnalytics1 === void 0 ? void 0 : _expandAnalytics1.linkName) !== null && _expandAnalytics_linkName !== void 0 ? _expandAnalytics_linkName : "",
    callback: React2.useCallback(function (referrerId, linkName) {
      clickTracker(referrerId, linkName);
    }, [clickTracker])
  };
  var _collapseAnalytics_referrerId, _collapseAnalytics_linkName;
  var expandoCollapseAnalytics = {
    id: (_collapseAnalytics_referrerId = (_collapseAnalytics = collapseAnalytics) === null || _collapseAnalytics === void 0 ? void 0 : _collapseAnalytics.referrerId) !== null && _collapseAnalytics_referrerId !== void 0 ? _collapseAnalytics_referrerId : "",
    description: (_collapseAnalytics_linkName = (_collapseAnalytics1 = collapseAnalytics) === null || _collapseAnalytics1 === void 0 ? void 0 : _collapseAnalytics1.linkName) !== null && _collapseAnalytics_linkName !== void 0 ? _collapseAnalytics_linkName : "",
    callback: React2.useCallback(function (referrerId, linkName) {
      clickTracker(referrerId, linkName);
    }, [clickTracker])
  };
  return /* @__PURE__ */React2.createElement(UitkExpandoPeek, {
    expandLabel: collapsedLabel,
    collapseLabel: expandedLabel,
    lines: lines,
    items: items,
    isVisible: isVisible,
    handleClick: handleClick,
    expandA11yLabel: collapsedLabel,
    collapseA11yLabel: expandedLabel,
    analytics: isVisible ? expandoCollapseAnalytics : expandoExpandAnalytics,
    hideScrim: hideScrim && true
  }, children);
};
EGDSExpandoPeek.fragment = fragment2;
EGDSExpandoPeek.displayName = "EGDSExpandoPeek";
// ../internal/src/components/ui-action-link/ui-action-link.tsx
import React3 from "react";
import { gql as gql3 } from "@apollo/client";
import { useClickTracker as useClickTracker2 } from "@shared-ui/clickstream-analytics-context";
var EGDSInlineLinkFragment = gql3(_templateObject2());
var fragment3 = gql3(_templateObject3());
var _obj;
var UILinkTargetMap = (_obj = {}, _define_property(_obj, "EXTERNAL" /* EXTERNAL */, "_blank"), _define_property(_obj, "INTERNAL" /* INTERNAL */, "_self"), _obj);
var UILinkAction = function (param) {
  var className = param.className,
    data = param.data,
    children = param.children;
  var accessibility = data.accessibility,
    resource = data.resource,
    target = data.target,
    analytics = data.analytics;
  var clickTracker = useClickTracker2();
  var onClick = React3.useCallback(function () {
    var _analytics_urls, _analytics, _analytics1, _analytics2;
    (_analytics = analytics) === null || _analytics === void 0 ? void 0 : (_analytics_urls = _analytics.urls) === null || _analytics_urls === void 0 ? void 0 : _analytics_urls.forEach(function (url) {
      var _navigator;
      (_navigator = navigator) === null || _navigator === void 0 ? void 0 : _navigator.sendBeacon(url);
    });
    if (((_analytics1 = analytics) === null || _analytics1 === void 0 ? void 0 : _analytics1.referrerId) && ((_analytics2 = analytics) === null || _analytics2 === void 0 ? void 0 : _analytics2.linkName)) {
      clickTracker(analytics.referrerId, analytics.linkName);
    }
  }, [clickTracker]);
  if (resource.__typename !== "HttpURI") {
    return null;
  }
  return /* @__PURE__ */React3.createElement("a", {
    className: className,
    target: UILinkTargetMap[target],
    href: resource.value,
    rel: "noopener noreferrer",
    onClickCapture: onClick
  }, accessibility && /* @__PURE__ */React3.createElement("span", {
    className: "is-visually-hidden"
  }, accessibility), children);
};
UILinkAction.fragment = fragment3;
UILinkAction.displayName = "UILinkAction";
// src/components/transparency/__private/__fragments/transparency-content.tsx
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { UitkLink } from "uitk-react-link";
import { UitkList, UitkListItem } from "uitk-react-list";
import { UitkSpacing } from "uitk-react-spacing";
import { UitkHeading, UitkText } from "uitk-react-text";
var fragment4 = gql4(_templateObject4(), EGDSExpandoPeek.fragment, EGDSInlineLinkFragment, UILinkAction.fragment);
var spacingDialogContent = {
  margin: "six"
};
var spacingSection = {
  padding: {
    blockstart: "two"
  }
};
var _obj1;
var EGDSLinkSizeMap = (_obj1 = {}, _define_property(_obj1, "SMALL" /* SMALL */, "small"), _define_property(_obj1, "LARGE" /* LARGE */, "large"), _define_property(_obj1, "MEDIUM" /* MEDIUM */, "medium"), _obj1);
var TransparencyContent = function (param) {
  var data = param.data;
  var entityMapper = function (entity, index) {
    return /* @__PURE__ */React4.createElement(UitkSpacing, {
      key: "entity-".concat(index),
      stid: "transparency-entity-".concat(index),
      padding: spacingSection.padding
    }, /* @__PURE__ */React4.createElement("div", null, /* @__PURE__ */React4.createElement(UitkText, {
      size: 100
    }, entity.label), entity.expando && /* @__PURE__ */React4.createElement(EGDSExpandoPeek, {
      lines: 3,
      data: entity.expando,
      hideScrim: false
    }, /* @__PURE__ */React4.createElement(UitkText, {
      size: 200,
      weight: "medium"
    }, entity.names))));
  };
  var getEntities = function (entities) {
    return /* @__PURE__ */React4.createElement(React4.Fragment, null, entities.map(function (entity, index) {
      return entityMapper(entity, index);
    }));
  };
  var getTargetingCategories = function (targetingCategories) {
    return /* @__PURE__ */React4.createElement(UitkSpacing, {
      padding: spacingSection.padding
    }, /* @__PURE__ */React4.createElement("div", null, /* @__PURE__ */React4.createElement(UitkHeading, {
      size: 7
    }, targetingCategories.heading.text), /* @__PURE__ */React4.createElement(UitkSpacing, null, /* @__PURE__ */React4.createElement(UitkList, null, targetingCategories.items.listItems.map(function (item, index) {
      return /* @__PURE__ */React4.createElement(UitkListItem, {
        key: "targeting-category-list-".concat(index)
      }, item.text);
    })))));
  };
  var getCallToAction = function (callToAction) {
    return /* @__PURE__ */React4.createElement(UitkSpacing, {
      padding: spacingSection.padding
    }, /* @__PURE__ */React4.createElement("div", null, /* @__PURE__ */React4.createElement(UitkLink, {
      inline: true,
      size: EGDSLinkSizeMap[callToAction.size]
    }, /* @__PURE__ */React4.createElement(UILinkAction, {
      data: callToAction.action
    }, callToAction.text))));
  };
  return /* @__PURE__ */React4.createElement(UitkLayoutFlex, {
    space: "two",
    direction: "column"
  }, /* @__PURE__ */React4.createElement(UitkLayoutFlexItem, null, /* @__PURE__ */React4.createElement(UitkSpacing, {
    margin: spacingDialogContent.margin
  }, /* @__PURE__ */React4.createElement("div", null, getEntities(data.entities), getTargetingCategories(data.targetingCategories), getCallToAction(data.callToAction)))));
};
TransparencyContent.fragment = fragment4;
TransparencyContent.displayName = "TransparencyContent";
// src/components/transparency/__private/loading-spinner.tsx
import React5 from "react";
import { UitkLayoutFlex as UitkLayoutFlex2, UitkLayoutFlexItem as UitkLayoutFlexItem2 } from "uitk-react-layout-flex";
import { UitkLoader } from "uitk-react-loader";
import { UitkSheetContent } from "uitk-react-sheet";
var TransparencyOverlayLoading = function () {
  return /* @__PURE__ */React5.createElement(UitkSheetContent, null, /* @__PURE__ */React5.createElement(UitkLayoutFlex2, {
    direction: "column",
    alignItems: "center"
  }, /* @__PURE__ */React5.createElement(UitkLayoutFlexItem2, null, /* @__PURE__ */React5.createElement(UitkLoader, null))));
};
// src/components/transparency/__private/transparency-overlay-error.tsx
import React6 from "react";
import { UitkPrimaryButton } from "uitk-react-button";
import { UitkIcon as UitkIcon2, UitkIconSize } from "uitk-react-icons";
import { UitkLayoutFlex as UitkLayoutFlex3, UitkLayoutFlexItem as UitkLayoutFlexItem3 } from "uitk-react-layout-flex";
import { UitkSheetContent as UitkSheetContent2 } from "uitk-react-sheet";
import { UitkSpacing as UitkSpacing2 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading2 } from "uitk-react-text";
var spacingSection2 = {
  padding: {
    blockstart: "two"
  }
};
var TransparencyOverlayError = function (param) {
  var errorData = param.errorData,
    clickCallback = param.clickCallback,
    showErrorContent = param.showErrorContent,
    loading = param.loading;
  var _errorData_icon, _errorData_icon1, _errorData_icon2, _errorData_icon3;
  var _React6_useState = _sliced_to_array(React6.useState(0), 2),
    retryCount = _React6_useState[0],
    setRetryCount = _React6_useState[1];
  if (!errorData || !showErrorContent || loading) {
    return null;
  }
  var isExceededRetryAttempts = function () {
    var _errorData;
    return retryCount >= (((_errorData = errorData) === null || _errorData === void 0 ? void 0 : _errorData.allowedRetryAttempts) || 0);
  };
  var retryButtonClickCallback = function () {
    clickCallback();
    setRetryCount(retryCount + 1);
  };
  return /* @__PURE__ */React6.createElement(UitkSheetContent2, null, /* @__PURE__ */React6.createElement(UitkLayoutFlex3, {
    direction: "column",
    alignItems: "center"
  }, /* @__PURE__ */React6.createElement(React6.Fragment, null, /* @__PURE__ */React6.createElement(UitkLayoutFlexItem3, null, /* @__PURE__ */React6.createElement(UitkSpacing2, {
    padding: spacingSection2.padding
  }, /* @__PURE__ */React6.createElement(UitkIcon2, {
    id: ((_errorData_icon = errorData.icon) === null || _errorData_icon === void 0 ? void 0 : _errorData_icon.id) || "info",
    name: ((_errorData_icon1 = errorData.icon) === null || _errorData_icon1 === void 0 ? void 0 : _errorData_icon1.id) || "info",
    title: ((_errorData_icon2 = errorData.icon) === null || _errorData_icon2 === void 0 ? void 0 : _errorData_icon2.id) || "info",
    size: UitkIconSize[((_errorData_icon3 = errorData.icon) === null || _errorData_icon3 === void 0 ? void 0 : _errorData_icon3.size) || UitkIconSize.MEDIUM]
  }))), /* @__PURE__ */React6.createElement(UitkLayoutFlexItem3, null, /* @__PURE__ */React6.createElement(UitkSpacing2, {
    padding: spacingSection2.padding
  }, /* @__PURE__ */React6.createElement(UitkHeading2, {
    align: "center"
  }, isExceededRetryAttempts() ? errorData.exceededAttemptsMessage : errorData.description))), errorData.button && !isExceededRetryAttempts() && /* @__PURE__ */React6.createElement(UitkLayoutFlexItem3, null, /* @__PURE__ */React6.createElement(UitkSpacing2, {
    padding: spacingSection2.padding
  }, /* @__PURE__ */React6.createElement("div", null, /* @__PURE__ */React6.createElement(UitkPrimaryButton, {
    onClick: function () {
      return retryButtonClickCallback();
    },
    name: "retry-transparency"
  }, errorData.button.primary)))))));
};
// src/components/transparency/transparency-overlay.tsx
var __Query = gql5(_templateObject5(), TransparencyContent.fragment);
var TransparencyOverlay = function (param) {
  var skeletonData = param.skeletonData,
    inputs = param.inputs;
  var _useDialog2 = _sliced_to_array(useDialog2("transparency-dialog-".concat(inputs.adTransparencyId)), 3),
    isDialogOpen = _useDialog2[0],
    dialogActions = _useDialog2[1],
    DialogComponent = _useDialog2[2];
  var context = useBexApi().context;
  var variables = _object_spread_props(_object_spread({}, inputs), {
    context: context
  });
  useEffect(function () {
    if (isDialogOpen) {
      executeQuery({
        variables: variables
      });
    }
  }, [isDialogOpen]);
  var _useLazyQuery = _sliced_to_array(useLazyQuery(__Query, {
      context: {
        useApq: true
      },
      ssr: false,
      notifyOnNetworkStatusChange: true,
      fetchPolicy: DEFAULT_SPONSORED_FETCH_POLICY
    }), 2),
    executeQuery = _useLazyQuery[0],
    _useLazyQuery_ = _useLazyQuery[1],
    data = _useLazyQuery_.data,
    error = _useLazyQuery_.error,
    loading = _useLazyQuery_.loading,
    refetch = _useLazyQuery_.refetch;
  var closeDialog = function () {
    dialogActions.closeDialog();
  };
  var renderSheet = function (sheetSize) {
    var _skeletonData, _skeletonData1, _data_sponsoredContent, _data;
    var sheetHeight = {
      SMALL: 450,
      MEDIUM: 700
    };
    return /* @__PURE__ */React7.createElement(UitkSheet, {
      liveAnnounceString: "Transparency Sheet has opened",
      type: "centered",
      centeredSheetSize: sheetSize.toLowerCase(),
      height: sheetHeight[sheetSize],
      triggerRef: null,
      isVisible: isDialogOpen
    }, /* @__PURE__ */React7.createElement(UitkToolbar, {
      navigationContent: {
        onClick: closeDialog,
        navIconLabel: "Close Toolbar"
      },
      toolbarTitle: ((_skeletonData = skeletonData) === null || _skeletonData === void 0 ? void 0 : _skeletonData.title) || ""
    }), loading && /* @__PURE__ */React7.createElement(TransparencyOverlayLoading, null), /* @__PURE__ */React7.createElement(React7.Fragment, null, /* @__PURE__ */React7.createElement(TransparencyOverlayError, {
      errorData: (_skeletonData1 = skeletonData) === null || _skeletonData1 === void 0 ? void 0 : _skeletonData1.error,
      clickCallback: refetch,
      showErrorContent: !!error,
      loading: loading
    }), !loading && !error && ((_data = data) === null || _data === void 0 ? void 0 : (_data_sponsoredContent = _data.sponsoredContent) === null || _data_sponsoredContent === void 0 ? void 0 : _data_sponsoredContent.transparencyOverlay) && /* @__PURE__ */React7.createElement(TransparencyContent, {
      data: data.sponsoredContent.transparencyOverlay
    })));
  };
  return /* @__PURE__ */React7.createElement(UitkSheetTransition, {
    isVisible: isDialogOpen
  }, /* @__PURE__ */React7.createElement(DialogComponent, null, /* @__PURE__ */React7.createElement(Viewport, null, /* @__PURE__ */React7.createElement(ViewMedium, null, renderSheet(ViewSizes.MEDIUM)), /* @__PURE__ */React7.createElement(ViewSmall, null, renderSheet(ViewSizes.SMALL)))));
};
TransparencyOverlay.displayName = "sharedui-TransparencyOverlay";
// src/components/transparency/transparency.tsx
import React8 from "react";
import { gql as gql6 } from "@apollo/client";
var fragment5 = gql6(_templateObject6(), TransparencyButton.fragment);
var Transparency = function (param) {
  var type = param.type,
    data = param.data,
    className = param.className;
  var adTransparencyId = data.adTransparencyId,
    adTransparencyButton = data.adTransparencyButton,
    adTransparencyOverlaySkeleton = data.adTransparencyOverlaySkeleton;
  if (!adTransparencyButton) {
    return null;
  }
  var inputs = {
    adTransparencyId: adTransparencyId
  };
  var transparencyButtonProps = {
    transparencyId: adTransparencyId,
    type: type,
    className: className
  };
  return /* @__PURE__ */React8.createElement(React8.Fragment, null, /* @__PURE__ */React8.createElement(TransparencyButton, _object_spread({
    data: adTransparencyButton
  }, transparencyButtonProps)), /* @__PURE__ */React8.createElement(TransparencyOverlay, {
    inputs: inputs,
    skeletonData: adTransparencyOverlaySkeleton
  }));
};
Transparency.fragment = fragment5;
Transparency.displayName = "sharedui-transparency";
export { Transparency, TransparencyTriggerType }; /* istanbul ignore file -- @preserve */